/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class bundleProductCarousel extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[bundle-product-carousel]',
      radioButtons: 'input[type="radio"]',
      labels: 'label[for^="bpc_"]',
    };
    
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        radioButtons: this.querySelectorAll(this.selectors.radioButtons),
        labels: this.querySelectorAll(this.selectors.labels),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          initialSlide: 0,
          slidesPerView: 2.8,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          }
        },
      },
    };
  }

  connectedCallback() {
    this.init();
    this.attachRadioEvents();
    this.attachLabelEvents();

    document.addEventListener('alexa:start-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = false;
    });

    document.addEventListener('alexa:end-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = true;
    });
  }

  init() {
    if (!this.settings.elements.slider)
      return;
    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  attachRadioEvents() {
    this.settings.elements.radioButtons.forEach(radio => {
      radio.addEventListener('change', this.handleRadioChange.bind(this));
    });
  }

  attachLabelEvents() {
    this.settings.elements.labels.forEach(label => {
      label.addEventListener('click', this.handleLabelClick.bind(this));
    });
  }

  handleLabelClick(event) {
    const label = event.target;
    const radioId = label.htmlFor;
    const radio = this.querySelector(`#${radioId}`);
    
    if (radio) {
      // Remove checked attribute from all radios with the same name
      this.settings.elements.radioButtons.forEach(r => {
        if (r.name === radio.name) {
          r.removeAttribute('checked');
        }
      });

      // Add checked attribute to the clicked radio
      radio.setAttribute('checked', 'checked');
      radio.checked = true;

      // Dispatch custom event for bundle validation
      document.dispatchEvent(new CustomEvent('dcb:change-bundle-variant', {
        detail: {
          id: radio.value,
          variantTitle: radio.dataset.value,
          available: radio.dataset.available || 'true'
        }
      }));
    }
  }

  handleRadioChange(event) {
    const changedRadio = event.target;
    const radioName = changedRadio.name;
    
    // Remove checked attribute from all radios with the same name
    this.settings.elements.radioButtons.forEach(radio => {
      if (radio.name === radioName) {
        radio.removeAttribute('checked');
      }
    });

    // Add checked attribute to the changed radio
    changedRadio.setAttribute('checked', 'checked');
    changedRadio.checked = true;

    // Dispatch custom event for bundle validation
    document.dispatchEvent(new CustomEvent('dcb:change-bundle-variant', {
      detail: {
        id: changedRadio.value,
        variantTitle: changedRadio.dataset.value,
        available: changedRadio.dataset.available || 'true'
      }
    }));
  }
}

customElements.define('bundle-product-carousel', bundleProductCarousel);
